import { useQuery } from 'react-query';
import { useCallback, useMemo } from 'react';
import axios from 'axios';
import { apiAuthBaseUrl } from 'config';
import { useAppSettings } from '../Contexts/AppSettingsProvider';
import { useAuth } from '../Contexts/AuthProvider';
import { appLangCode } from '../helpers';

const getItemTypes = async (lang, type = 'jobs') => {
    const {data} = await axios(`${apiAuthBaseUrl}/items/types/${type}`, {
        headers: { 'Accept-Language': appLangCode(lang) },
    })
    return data;
}

const isWellboreRelated = (item) => {
    const normalizedType = (item.itemType || '').toLowerCase().replace(/[^a-z]/g, '');
    return normalizedType.includes('pumpingschedule') || normalizedType.includes('wellbore');
}

export default function useItemTypes(type) {
    const { appLanguage, loading } = useAppSettings();
    const { currentUser } = useAuth();
    const queryKey = useMemo(() => ['item-types', type, appLanguage], [type, appLanguage]);
    // Pumping Schedule / Wellbore View are job-only items, available to companies with wellbore data enabled
    const allowWellbore = type === 'jobs' && !!currentUser?.showWellboreData?.();

    const select = useCallback(
        (data) => allowWellbore ? data : data.filter((item) => !isWellboreRelated(item)),
        [allowWellbore]
    );

    return useQuery(queryKey, () => getItemTypes(appLanguage, type), {
        initialData: [],
        keepPreviousData: true,
        enabled: !loading && !!appLanguage,
        refetchOnWindowFocus: false,
        select,
    });
}
